import styled from 'styled-components';

import { Icon } from 'coreOld/elements';
import { CSSProperties } from 'react';

export const spinnerStyle = {
  width: 25,
  height: 25,
  fill: '#fff',
};

export const SpinnerIcon = styled.div`
  margin-right: 10px;
  animation: rotate 2s linear infinite;
  font-size: inherit;
  font-weight: 600;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoaderSpinner = ({ style = spinnerStyle }: { style?: CSSProperties }) => {
  return (
    <SpinnerIcon>
      <Icon name={Icon.LOADING_SPINNER} style={style} />
    </SpinnerIcon>
  );
};

export default LoaderSpinner;
